import { makeStyles } from "@material-ui/core/styles";

export const carouselStyles = makeStyles({
  carouselContainer: {
    position: "relative",
    width: "100%",
  },
  overflowHidden: {
    overflow: "hidden",
  },
  flexContainer: {
    display: "flex",
  },
  horizontalSpacing: {
    marginLeft: "0rem",
  },
  verticalSpacing: {
    marginTop: "0rem",
    flexDirection: "column",
  },
  carouselItem: {
    minWidth: 0,
    flex: "0 0 auto",
  },
  horizontalItemSpacing: {
    paddingLeft: "0rem",
  },
  verticalItemSpacing: {
    paddingTop: "0rem",
  },

  carouselBtnIconWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#EDF3F3",
    borderRadius: "50%",
  },
});

export const carouselSxStyles = {
  buttonBase: {
    minWidth: "0px ",
    Selection: "none",
    zIndex: "10",
    "&.Mui-disabled": {
      pointerEvents: "all",
      cursor: "not-allowed",
      opacity: "0.6",
    },
  },

  baseStyles: {
    position: "absolute",
    height: "100%",
    width: "32px ",
    border: "1px solid #E6EFEF",
    borderRadius: "0px",
    padding: "4px",
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "#F7FAFA",
    },
    "&:active": {
      backgroundColor: "#E2E8F0",
    },
  },
  prevButtonHorizontal: {
    left: "0px",
    top: "0px",
  },
  prevButtonVertical: {
    top: "0px",
    left: "0px",
  },
  nextButtonHorizontal: {
    right: "0px",
    top: "0px",
  },
  nextButtonVertical: {
    bottom: "0px",
    left: "0px",
  },
};
